<script setup>
// The /events page in Trailhead: the design's page header, then the
// upcoming occurrences as a featured event, tag filters and the list.
// Built from the blocks a manager can place on any page, so the index
// cannot drift from them.
import { computed } from 'vue';
import ThPageHeader from './ThPageHeader.vue';
import ThEvents from './ThEvents.vue';

const props = defineProps({
    upcoming: { type: Array, default: () => [] },
    icalHref: { type: String, default: '/events.ics' },
    accent: { type: String, default: '' },
    org: { type: Object, default: () => ({}) },
    site_data: { type: Object, default: () => ({}) },
});

const header = computed(() => ({
    tone: 'tint',
    eyebrow: 'Calendar',
    title: 'Events',
    subtitle: 'Workdays, rides, races and gatherings. Everyone is welcome.',
    cta: { label: 'Subscribe to the calendar', href: props.icalHref },
}));
const EVENTS = { source: 'auto', layout: 'featured', show_filters: true, upcoming_count: 'all' };

function hhmm(t) {
    return t ? String(t).slice(0, 5) : '';
}
// The index's occurrence rows, in the shape the events block reads.
const rows = computed(() => props.upcoming.map((e) => {
    const d = e.date ? new Date(`${e.date}T00:00:00`) : null;
    const time = e.all_day ? 'All day'
        : (e.start_time && e.end_time ? `${hhmm(e.start_time)}–${hhmm(e.end_time)}` : hhmm(e.start_time));
    return {
        id: e.id,
        name: e.title,
        date: e.date,
        month: d ? d.toLocaleDateString('en-US', { month: 'short' }).toUpperCase() : '',
        day: d ? String(d.getDate()) : '',
        time,
        location: e.location,
        tag: e.tag,
        audience: e.audience,
        href: e.href,
    };
}));
</script>

<template>
    <ThPageHeader :config="header" :accent="accent" :org="org" />
    <ThEvents class="th-index" :config="EVENTS" :accent="accent" :org="org" :site_data="{ events: rows }" />
</template>

<style scoped>
.th-sec.th-index { padding-top: clamp(32px, 5vw, 56px); padding-bottom: clamp(48px, 7vw, 96px); }
</style>
